import { ExcelExportParams, ExcelStyle } from "ag-grid-community";

// Export settings for Excel export
export function getExportCoverPage(filterDetails: string, exportName: string): ExcelExportParams {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    };
    const formattedDate = now.toLocaleString('en-US', options);
    return { 
      prependContent: [
          {
            cells: [
              { data: { type: "String", value: "Details" }, styleId: "coverPageMainHeader" }
            ]
          },
          {
            cells: [
              { data: { type: "String", value: "Name:" }, styleId: "coverPageHeading" },
              { data: { type: "String", value: exportName } }
            ]
          },         
          {
            cells: [
              { data: { type: "String", value: "Filter Details:" } , styleId: "coverPageHeading"},
              { data: { type: "String", value: filterDetails}, styleId: "wrapText" }
            ]
          },
          {
            cells: [
              { data: { type: "String", value: "Date Generated:" }, styleId: "coverPageHeading" },
              { data: { type: "String", value: formattedDate  } }
            ]
          }
        ],       
        processHeaderCallback: () => "",
        processCellCallback: () => "",
        sheetName: "Details",
        columnWidth: 400
    }!;
  }

  export function getExportStyles(): ExcelStyle[]{
    return(
        [
            {
                id: 'header',
                font: {
                    bold: true
                }
            },
            {
                id:'numberAsString',
                dataType: 'String'
            },
            {
                id:'moneyField',
                numberFormat: {
                    format: '$#,##0.00',
                }
            },		
            {
                id: 'wrapText',
                alignment: {
                    wrapText: true,
                    vertical: "Top",
                    shrinkToFit: true								
                },
                
            },
            {
                id: 'top',
                alignment: {
                    vertical: "Top",
                },
            },
            {
                id: 'coverPageMainHeader',
                alignment: {
                    vertical: "Top",
                    horizontal: "Right",
                },
                font: {
                    bold: true,
                    size: 14
                }
            },
            {
                id: 'coverPageHeading',
                alignment: {
                    vertical: "Top",
                    horizontal: "Right",
                },
                font: {
                    bold: true,
                }
            },
        ]);
  }